// extracted by mini-css-extract-plugin
export default {"container":"Tasks_container__bDDr8","task":"Tasks_task__qcMka","photo":"Tasks_photo__i2iQ2","content":"Tasks_content__JJ33q","tasks":"Tasks_tasks__NTHE4"};